import { createTheme, Shadows } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    background: {
      default: '#C7C7C7',
      paper: '#FFFFFF',
    },
    primary: {
      main: '#7c5ec2', 
      dark: '#513e80',
      light: '#7c5ec21f'
    },
    secondary: {
      main: '#ca4d8c',
      light: '#ca4d8b27'
    },
    text: {
      primary: '#000000',
      secondary: '#838383',
    },
  },
  shadows: [
    'none',
    '0 1px 2px rgba(16,24,40,0.06)',
    '0 4px 10px rgba(16,24,40,0.10)',
    '0 14px 34px rgba(16,24,40,0.14)',
    ...Array(21).fill('none'),
  ] as Shadows,
});